<template>
    <div>
        <v-tooltip top dark color="black">
            <template v-slot:activator="{ on, attrs }">
                <v-badge left bordered icon="mdi-crown-outline" :color="colorAsRoute" offset-x="20" offset-y="20" avatar
                    dark v-if="!premium" class="!absolute !bottom-10 !right-24 z-10 !border-transparent ">
                    <v-btn fab dark x-large class=" !rounded-[30px] " color="black" elevation="5"
                        @click.prevent="openSubscribeToPremiumDialog()" v-bind="attrs" v-on="on">
                        <v-icon x-large color="green">
                            mdi-spotify
                        </v-icon>
                    </v-btn>
                </v-badge>
            </template>
            <span :class="`${routeLink}_text_color`">Spotify For <strong>Premium Members</strong></span>
        </v-tooltip>
        <v-tooltip top dark color="black">
            <template v-slot:activator="{ on, attrs }">
                <v-btn dark x-large class=" !rounded-[30px]  !absolute !bottom-10 !right-24 z-10 " color="black"
                    elevation="5" v-if="premium" v-bind="attrs" v-on="on">
                    <v-icon x-large class="green">
                        mdi-spotify
                    </v-icon>
                </v-btn>
            </template>
            <span :class="`${routeLink}_text_color`">Spotify</span>
        </v-tooltip>

        <SubscribePremiumDialog />
    </div>
</template>
<script>
import SubscribePremiumDialog from './settings/SubscribePremiumDialog.vue';

export default {
    data() {
        return {
            // dialog: false
        };
    },
    computed: {
        premium() {
            return this.$store.getters.isPremium;
        },
        colorAsRoute() {
            if (this.routeLink == "straight") {
                return "#a07a1d";
            }
            else if (this.routeLink == "gay") {
                return "#88c3fa";
            }
            else if (this.routeLink == "lesbian") {
                return "#9e2eec";
            }
        },
    },
    methods: {
        premiumDialog() {
            this.openSubscribeToPremiumDialog()
        },
        setUserProfile() {
            this.dialog = false,
                this.$store.dispatch("premium");
        },
    },
    components: { SubscribePremiumDialog }
}

</script>
<style scoped>
.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}



.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(39deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%);
}


.straight_text_color {

    color: #a07a1d;
}

.gay_text_color {
    color: #88c3fa;
}

.lesbian_text_color {
    color: #9e2eec;
}
</style>